// AIDEV-NOTE: Branding contacts are code-owned; update them here rather than via deployment env.
export const SUPPORT_CONTACT_EMAIL = "hello@partscompanion.org";
